import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const Container = styled(Box)`
  .root-services-tab {
    &__tab {
	  color: #383838 !important; 
    }
  }
`;

export default Container;
